// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__NIWzu","fullWidth":"Input_fullWidth__kV7Ic"};